module.exports = __webpack_public_path__ + "img/03_Button-7.44ace268.png";